import { Label, LABEL_COMPACT_SIZE, LABEL_SIZE_20 } from '../../Label'
import { Container } from '../Container'

import * as styles from './Labels.module.css'

function Labels() {
  const LABEL_BG_COLOR = '#a0b95c'

  return (
    <>
      <Container label='Label, sizes - 24px, 20px, 4px'>
        <Label
          backgroundColor={LABEL_BG_COLOR}
          className={styles.rightMargin}
          text='Label'
        />
        <Label
          backgroundColor={LABEL_BG_COLOR}
          className={styles.rightMargin}
          height={LABEL_SIZE_20}
          text='Label'
        />
        <Label
          backgroundColor={LABEL_BG_COLOR}
          height={LABEL_COMPACT_SIZE}
          text='Label'
        />
      </Container>
      <Container label='Label, with long text, sizes - 24px, 20px'>
        <Label
          backgroundColor={LABEL_BG_COLOR}
          className={styles.rightMargin}
          text='Label Label Label Label Label Label Label Label Label Label Label Label Label'
        />
        <Label
          backgroundColor={LABEL_BG_COLOR}
          height={LABEL_SIZE_20}
          text='Label Label Label Label Label Label Label Label Label Label Label Label Label'
        />
      </Container>
      <Container label='Label, with close button, sizes - 24px, 20px'>
        <Label
          backgroundColor={LABEL_BG_COLOR}
          className={styles.rightMargin}
          text='Label'
          onRemove={() => {
            console.log()
          }}
        />
        <Label
          backgroundColor={LABEL_BG_COLOR}
          height={LABEL_SIZE_20}
          text='Label'
          onRemove={() => {
            console.log()
          }}
        />
      </Container>
      <Container label='Label, with long text, with close button, sizes - 24px, 20px'>
        <Label
          backgroundColor={LABEL_BG_COLOR}
          className={styles.rightMargin}
          text='Label Label Label Label Label Label Label Label Label Label Label Label Label'
          onRemove={() => {
            console.log()
          }}
        />
        <Label
          backgroundColor={LABEL_BG_COLOR}
          height={LABEL_SIZE_20}
          text='Label Label Label Label Label Label Label Label Label Label Label Label Label'
          onRemove={() => {
            console.log()
          }}
        />
      </Container>
    </>
  )
}

export default Labels
